import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../lib/api';
import { AddAchievementModal } from '../components/kanban/add-achievement-modal';

export const Route = createFileRoute('/achievements')({ component: AchievementsPage });

interface Achievement {
  id: string;
  name: string;
  type: 'due_date' | 'recurring';
  status: 'active' | 'completed' | 'failed' | 'archived';
  categoryId: string | null;
  currentLevel: number;
  occurrenceCount: number;
  freqCount: number | null;
  freqPeriodHours: number | null;
  dueAt: string | null;
}

function AchievementsPage() {
  const list = useQuery({ queryKey: ['achievements'], queryFn: () => api<Achievement[]>('/api/achievements') });
  const [addOpen, setAddOpen] = useState(false);

  const all = list.data ?? [];
  const active = all.filter((a) => a.status === 'active');
  const done = all.filter((a) => a.status !== 'active');

  return (
    <div className="mx-auto max-w-5xl px-6 py-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-neutral-100">Achievements</h1>
        <button
          onClick={() => setAddOpen(true)}
          className="rounded-md bg-brand-500 px-3 py-2 text-sm font-medium text-white hover:bg-brand-600"
        >
          + Yeni achievement
        </button>
      </div>

      <section className="mb-8">
        <h2 className="mb-3 flex items-center gap-2 text-sm font-semibold text-ach-400">
          🏆 Aktif
          <span className="font-pixel text-[10px] text-neutral-500">{active.length}</span>
        </h2>
        {active.length === 0
          ? <Empty label="Henüz aktif achievement yok" />
          : <ul className="space-y-2">{active.map((a) => <Item key={a.id} a={a} />)}</ul>}
      </section>

      <section>
        <h2 className="mb-3 flex items-center gap-2 text-sm font-semibold text-neutral-500">
          ✅ Bitmiş
          <span className="font-pixel text-[10px] text-neutral-600">{done.length}</span>
        </h2>
        {done.length === 0
          ? <Empty label="Henüz biten achievement yok" />
          : <ul className="space-y-2">{done.map((a) => <Item key={a.id} a={a} dim />)}</ul>}
      </section>

      {addOpen && <AddAchievementModal onClose={() => setAddOpen(false)} />}
    </div>
  );
}

function Item({ a, dim }: { a: Achievement; dim?: boolean }) {
  return (
    <li className={`rounded-xl border border-border-soft bg-bg-raised p-4 ${dim ? 'opacity-50' : ''}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="font-medium text-neutral-100">{a.name}</p>
          <p className="text-xs text-neutral-400">
            {a.type === 'recurring'
              ? `Lv ${a.currentLevel} · ${a.occurrenceCount} tamamlanma · ${a.freqCount}/${a.freqPeriodHours}h`
              : a.dueAt ? `son: ${new Date(a.dueAt).toLocaleDateString('tr-TR')}` : ''}
          </p>
        </div>
        <span className="font-pixel text-[10px] text-neutral-500">{a.status}</span>
      </div>
    </li>
  );
}

function Empty({ label }: { label: string }) {
  return (
    <div className="rounded-xl border border-dashed border-border-soft bg-bg-raised/40 p-6 text-center text-sm text-neutral-500">
      {label}
    </div>
  );
}
